import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal, MaskLine } from "@/components/Reveal";

const StatSection = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const bgY = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

  return (
    <section
      id="gap"
      ref={ref}
      data-testid="stat-section"
      className="relative overflow-hidden bg-background px-6 py-24 md:px-12 md:py-32"
    >
      <motion.img
        src="https://images.pexels.com/photos/6203470/pexels-photo-6203470.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
        alt=""
        style={{ y: bgY }}
        className="pointer-events-none absolute inset-0 h-[116%] w-full object-cover opacity-[0.07] mix-blend-luminosity"
      />
      <div className="relative z-10 mx-auto max-w-[1400px]">
        <Reveal>
          <p className="text-xs font-bold uppercase tracking-[0.22em] text-accent md:text-sm">
            Why Financial Literacy Can't Wait
          </p>
        </Reveal>

        <div className="mt-10 grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-6">
          <div className="lg:col-span-8">
            <h2 className="font-display font-medium leading-none tracking-tightest text-primary">
              <MaskLine className="text-[24vw] leading-[1] pb-[0.08em] lg:text-[15vw]">27%</MaskLine>
            </h2>
            <Reveal delay={0.2}>
              <p className="mt-4 font-display text-3xl italic text-primary/70 md:text-4xl">
                of India is financially literate.
              </p>
            </Reveal>
          </div>

          <div className="flex flex-col justify-end lg:col-span-4">
            <Reveal delay={0.15}>
              <p className="text-lg font-light leading-relaxed text-foreground/80 md:text-xl">
                India has more people with bank accounts than ever before — but access
                to a bank isn't the same as knowing what to do with your money.
              </p>
              <p className="mt-6 text-lg font-medium text-primary">
                That gap is exactly where this page comes in — let's change it, one
                conversation at a time.
              </p>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StatSection;
